import type {Module} from "vuex";
import type {CustomLocale} from "flatpickr/dist/types/locale";
import type {RootState} from "@/store/types";
import {getPickerConfig} from "@/store/picker/config";

export interface PickerDateConfig {
    enableTime: boolean
    noCalendar: boolean
    disableMobile: boolean
    dateFormat: string
    altInput: boolean
    altFormat: string
    locale: CustomLocale
}

export interface PickerState {
    locale: string | null
}

const generateDateConfig = (locale: string): PickerDateConfig => ({
    enableTime: false,
    noCalendar: false,
    disableMobile: true,
    dateFormat: "U",
    altInput: true,
    altFormat: getPickerConfig(locale).displayDateFormat,
    locale: getPickerConfig(locale).locale
})

const picker: Module<PickerState, RootState> = {
    namespaced: true,
    state: {
        locale: null
    },
    getters: {
        // The locale must be set (setLocale) before the date config is read
        dateConfig: (state): PickerDateConfig => generateDateConfig(state.locale as string)
    },
    mutations: {
        setLocale: (state, locale: string | null) => state.locale = locale
    },
    actions: {
        setLocale: (context, locale: string | null) => context.commit("setLocale", locale)
    }
}

export default picker
